import {writable} from "svelte/store";

export const enableSSO = writable({
	microsoft: false,
	google: false,
});
